const getStyles = (_options) => ``;

export default getStyles;
